// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
  top: 10px;
  position: fixed;
  width: 300px;
  background: white;
  left: auto;
  right: auto;
}

.modal-body {
  overflow-x: auto !important;
  max-height: 80vh;
}

.modal-body ::ng-deep .list-group {
  max-height: 60vh;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/modal/modal.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AACF;;AACA;EACE,2BAAA;EACA,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,cAAA;AAEF","sourcesContent":[".modal-container {\n  top: 10px;\n  position: fixed;\n  width: 300px;\n  background: white;\n  left: auto;\n  right: auto;\n}\n.modal-body {\n  overflow-x: auto !important;\n  max-height: 80vh;\n}\n\n.modal-body ::ng-deep .list-group {\n  max-height: 60vh;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
